import * as Sentry from '@sentry/browser';
import { isObject, merge, partition } from 'lodash-es';
import { getAdtractionId } from './adtraction';
import { getAnalyticsV4TrackingParameters } from './analytics-4';
import { getBingTrackingParameters } from './bing';
import { getFacebookTrackingParameters } from './facebook';
import { getTaboolaClickId } from './taboola';

export async function runMarketingPipeline() {
  try {
    const marketingPipelineResults = await Promise.allSettled([
      getFacebookTrackingParameters(),
      getAnalyticsV4TrackingParameters(),
      getTaboolaClickId(),
      getBingTrackingParameters(),
      getAdtractionId(),
    ]);

    const [successResults, failedResults] = partition(marketingPipelineResults, (result) => result.status === 'fulfilled' && isObject(result.value));

    if (failedResults.length > 0) {
      failedResults.forEach((result) => {
        if (!isObject(result.value)) {
          console.log(`Marketing callback did not return an object: ${result.value}`);
          Sentry.captureMessage(`Marketing callback did not return an object: ${result.value}`);
        }

        console.log(`Marketing callback failed unexpectedly, reason: ${result.reason}`);
        Sentry.captureMessage(`Marketing callback failed unexpectedly, reason: ${result.reason}`);
      });
    }

    return successResults.reduce((previous, current) => merge(previous, current.value), {});
  } catch (error) {
    Sentry.captureException(error);
    return {};
  }
}
